import { lazy, Suspense } from 'react';
import { Route, Navigate } from 'react-router-dom';

const CostDashboardPage = lazy(() => import('./pages/CostDashboardPage'));
const TopicsManagementPage = lazy(() => import('./pages/TopicsManagementPage'));
const PoliciesPage = lazy(() => import('./pages/PoliciesPage'));
const TriggersPage = lazy(() => import('./pages/TriggersPage'));
const TaskSchedulerPage = lazy(() => import('./pages/TaskSchedulerPage'));

const PageSuspense = ({ children }: { children: React.ReactNode }) => (
  <Suspense fallback={
    <div className="flex items-center justify-center min-h-[40vh]">
      <div className="flex items-center gap-3 text-neutral-400 animate-pulse">
        <div className="w-5 h-5 border-2 border-current border-t-transparent rounded-full animate-spin" />
        Loading...
      </div>
    </div>
  }>
    {children}
  </Suspense>
);

/**
 * Operations route children — workspace-scoped pages.
 * Composed into the parent <Routes> in App.tsx.
 */
export function OpsRouteChildren() {
  return (
    <>
      <Route index element={<Navigate to="costs" replace />} />
      <Route path="costs" element={<PageSuspense><CostDashboardPage /></PageSuspense>} />
      <Route path="topics" element={<PageSuspense><TopicsManagementPage /></PageSuspense>} />
      <Route path="policies" element={<PageSuspense><PoliciesPage /></PageSuspense>} />
      <Route path="policies/:itemId" element={<PageSuspense><PoliciesPage /></PageSuspense>} />

      {/* WORKFLOW */}
      <Route path="triggers" element={<PageSuspense><TriggersPage /></PageSuspense>} />
      <Route path="scheduler" element={<PageSuspense><TaskSchedulerPage /></PageSuspense>} />

      {/* Legacy 2-letter code redirects */}
      <Route path="ct" element={<Navigate to="../costs" replace />} />
      <Route path="tm" element={<Navigate to="../topics" replace />} />
      <Route path="po" element={<Navigate to="../policies" replace />} />
      <Route path="po/:itemId" element={<Navigate to="../policies" replace />} />
      <Route path="tc" element={<Navigate to="../triggers" replace />} />
      <Route path="rt" element={<Navigate to="../scheduler" replace />} />
    </>
  );
}
